/** Trie décroissant par consommation tokens. */
export function u3207SortByTokensDesc<T extends { tokens: number }>(rows: T[]): T[] {
  return [...rows].sort((a, b) => b.tokens - a.tokens);
}

/** Top N ou liste complète selon `showAll`. */
export function u3207VisibleRows<T>(rows: T[], topN: number, showAll: boolean): T[] {
  if (showAll || topN <= 0 || rows.length <= topN) return rows;
  return rows.slice(0, topN);
}

export const U3207_CATEGORY_TOP_N = 5;
